import loadScript from '@tencent/midas-libs/dist/es/load-script';
import { xMidasInit } from '@/utils/x-midas';
import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

const loadScriptPromise = (src) =>
  new Promise((resolve, reject) => {
    loadScript(src, (result) => {
      if (result) {
        resolve(result);
      } else {
        reject(new Error(`loadScript fail: ${result}`));
      }
    });
  });

const globals = /appid/.test(location.search) ? location.search.slice(1) : '';

Promise.all([
  loadScriptPromise(`/interface/event-data.js?${globals}`),
  loadScriptPromise(`/xmidas-sdk.js`),
  loadScriptPromise(`https://cdn.midasbuy.com/h5/overseah5/js/midas-oversea-h5page.js`),
])
  .then(() => {
    return new Promise((resolve) => {
      const int = setInterval(async () => {
        if (window.xMidas) {
          clearInterval(int);
          xMidasInit();
          window.evt = JSON.parse(JSON.stringify(window.eventData));
          resolve();
        }
      }, 50);
    });
  })
  .then(() => {
    new Vue({
      render: (h) => h(App),
    }).$mount('#app');
  });
